import { create } from 'apisauce'
import Cookies from 'js-cookie';

// define the api

const connection = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : 'https://api.taffytree.com'
const fileConnection = process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : 'https://api.taffytree.com'
const jwt = Cookies.get('jwt');
const jwt_refresh = Cookies.get('jwt_refresh');
const headers = { Authorization: `Bearer ${jwt}` }
const api = create({ baseURL: connection, headers: headers, timeout: 60000 })
const ext_api = create({ baseURL: connection, headers: headers, timeout: 60000 })
const fileApi = create({ baseURL: fileConnection,timeout: 60000 })
const rheaders = { Authorization: `Bearer ${jwt_refresh}` }
const refresh_api = create({ baseURL: connection, headers: rheaders, timeout: 60000 })
const file_base_url = import.meta.env.VITE_FILE_BASE_URL || 'https://files.taffytree.com/';

// Handle all 401 errors by redirecting to login.
api.addResponseTransform(r => {
  if (window.location.pathname !== '/login') {
    if (r.status === 480) {
      const payload = {
        action: 'navigate',
        path: '/settings/billing'
      };
      window.parent.postMessage(payload, connection);
    }
    else if (r.status === 401 || r.status === 403) {
      const payload = {
        action: 'login'
      };
      window.parent.postMessage(payload, connection);
      return Promise.reject(r);
    }
    else if (r.status === 422) {
      console.log(r);
    }
  }
});

ext_api.addResponseTransform(r => {
  if (window.location.pathname !== '/login') {
    if (r.status === 401 || r.status === 403) {
      const payload = {
        action: 'login'
      };
      window.parent.postMessage(payload, connection);
      return Promise.reject(r);
    }
    else if (r.status === 422) {
      //
    }
  }
});

refresh_api.addResponseTransform(r => {
  if (r.status === 401 || r.status === 403) {
    const payload = {
      action: 'login'
    };
    window.parent.postMessage(payload, connection);
    return Promise.reject(r);
  } else if (r.status === 422) {
    //
  }
});

function upload_headers() {
  return [headers]
}

export { api, ext_api, fileApi, refresh_api, connection, fileConnection, headers, file_base_url }
